import { useI18n } from "@/i18n/I18nProvider";
import { useTheme } from "@/hooks/useTheme";

const SUN = (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
);
const MOON = (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
);

export default function ThemeToggle() {
    const { t } = useI18n();
    const { theme, toggle } = useTheme();
    const dark = theme === "dark";
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-toggle"
            aria-label={dark ? t("theme.toLight") : t("theme.toDark")}
            aria-pressed={dark}
            className="itly-theme-toggle"
        >
            <span className={`itly-theme-toggle-knob${dark ? " is-dark" : ""}`}>{dark ? MOON : SUN}</span>
        </button>
    );
}
